// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"c4723b1c","264":"bce39700","384":"7897308a","413":"33429b39","541":"aafb56bf","566":"d3ba9a5c","770":"f09ea945","790":"54c7e704","926":"e4531ce6","963":"eb970b31"}[chunkId] + ".chunk.js";
};